import global from '../global'

const giveAdd = global.serverUrl + '/backstage/spread/give/add'
export default {
  giveAdd
}



// WEBPACK FOOTER //
// ./src/config/api/spread.js